<div class="layout-main">
  <div class="container-fluid">
    <div class="pb-2 mb-3 border-bottom">
      <h3><b>Audit trail</b></h3>
    </div>
    <div class="row">
      <div class="col-12">
        <p-panel [toggleable]="true">
          <ng-template pTemplate="header">
            <div class="filter-card-header">
              <span class="filter-icon"><i class="fa fa-search"></i></span>
              <span class="filter-card-title">Filter</span>
            </div>
          </ng-template>
          <div class="filter-fields">
            <div class="filter-field">
              <p-floatLabel>
                <p-dropdown (onChange)="search()" [(ngModel)]="auditTrailFilterCriteria.action"
                            [options]="actionItems" name="action" showClear="true"></p-dropdown>
                <label>Action</label>
              </p-floatLabel>
            </div>
            <div class="filter-field" *ngIf="isMckayUser">
              <p-floatLabel>
                <p-dropdown (onChange)="search()" [(ngModel)]="auditTrailFilterCriteria.companyUniqid"
                            [filter]="true" [options]="companyItems" name="company" showClear="true"></p-dropdown>
                <label>Company</label>
              </p-floatLabel>
            </div>
            <div class="filter-field filter-field--range">
              <p-floatLabel>
                <p-calendar (onClearClick)="search()" (onSelect)="searchOnCompleteDateRange()"
                            [(ngModel)]="dateRange" [showButtonBar]="true" [showIcon]="true"
                            [style]="{'width':'100%'}" dataType="string" dateFormat="mm/dd/yy"
                            inputId="auditDateRange" name="auditDateRange" selectionMode="range"></p-calendar>
                <label for="auditDateRange">Date range</label>
              </p-floatLabel>
            </div>
            <div class="filter-actions">
              <button (click)="resetFilters()" class="filter-reset-btn" type="button">
                <i aria-hidden="true" class="fa fa-refresh"></i>
                Reset
              </button>
            </div>
          </div>
        </p-panel>
      </div>
    </div>
    <p-table (onLazyLoad)="loadLazy($event)" [first]="first" [lazy]="true" [loading]="loading" [paginator]="true"
             [rows]="pageSize" [rowsPerPageOptions]="[25, 50, 100, 200]" [totalRecords]="totalItems"
             [value]="auditEntries">
      <ng-template pTemplate="loadingicon">
        <p-progressSpinner [style]="{width: '48px', height: '48px'}" animationDuration="1.2s"
                           strokeWidth="4"></p-progressSpinner>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th *ngFor="let col of cols" class="th-{{col.field}}" [style.width]="col.width">{{ col.header }}</th>
        </tr>
      </ng-template>
      <ng-template let-entry pTemplate="body">
        <tr>
          <td class="when-cell">{{ entry.createdAt | date:'MMM d, y H:mm' }}</td>
          <td class="record-cell">{{ entry.objectLabel }}</td>
          <td>
            <span class="action-badge action-badge--{{entry.action}}">{{ auditUtilsService.getActionLabel(entry.action) }}</span>
          </td>
          <td class="changes-cell">
            <div *ngIf="entry.changes?.length; else noChange" class="change-list">
              <div *ngFor="let change of entry.changes" class="change-row">
                <ng-container *ngIf="auditUtilsService.isRoleChange(entry); else fieldDiff">
                  <span class="change-field">{{ auditUtilsService.getRoleChangeLabel(entry) }}:</span>
                  <span class="change-new">{{ auditUtilsService.getRoleName(change) }}</span>
                </ng-container>
                <ng-template #fieldDiff>
                  <span *ngIf="auditUtilsService.isPasswordChange(change); else valueDiff" class="change-field">Password changed</span>
                </ng-template>
                <ng-template #valueDiff>
                  <span class="change-field">{{ auditUtilsService.getFieldLabel(change.field) }}</span>
                  <span class="change-old">{{ auditUtilsService.getDisplayedValue(change.old) }}</span>
                  <i aria-hidden="true" class="fa fa-long-arrow-right change-arrow"></i>
                  <span class="change-new">{{ auditUtilsService.getDisplayedValue(change.new) }}</span>
                </ng-template>
              </div>
            </div>
            <ng-template #noChange><span class="change-empty">-</span></ng-template>
          </td>
          <td class="actor-cell">
            <span *ngIf="entry.actor === 'restricted'" class="actor-restricted">Restricted</span>
            <span *ngIf="entry.actor !== 'restricted'">{{ entry.actor || 'system' }}</span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="cols.length">
            <div *ngIf="loadError" class="empty-state">
              <i aria-hidden="true" class="fa fa-exclamation-triangle"></i>
              <div class="empty-state-title">The audit trail could not be loaded</div>
              <div class="empty-state-subtitle">Please try again later.</div>
            </div>
            <div *ngIf="!loadError" class="empty-state">
              <i aria-hidden="true" class="fa fa-search"></i>
              <div class="empty-state-title">No audit entry found</div>
              <div class="empty-state-subtitle">Try adjusting your search or filters.</div>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
